if (document.getElementById("fly-catcher")) {
  const r = new rive.Rive({
      src: "https://cdn.shopify.com/s/files/1/0978/8886/2545/files/fly_catcher_060c4d6e-43d3-418c-b027-64e35c0ce024.riv?v=1768461082",
      canvas: document.getElementById("fly-catcher"),
      autoplay: true,
      onLoad: () => {
          r.resizeDrawingSurfaceToCanvas();
      },
  });
}
if (document.getElementById("fly-catcher2")) {
  const fly2 = new rive.Rive({
    src: "https://cdn.shopify.com/s/files/1/0978/8886/2545/files/fly_catcher_060c4d6e-43d3-418c-b027-64e35c0ce024.riv?v=1768461082",
    canvas: document.getElementById("fly-catcher2"),
    autoplay: true,
    onLoad: () => {
        fly2.resizeDrawingSurfaceToCanvas();
    },
});
}
document.querySelectorAll('.hover-anim-target').forEach((el) => {
  const riveSrc = el.getAttribute('data-rive');
  if (riveSrc && el instanceof HTMLCanvasElement) {
    const rInstance = new rive.Rive({
      src: riveSrc,
      canvas: el,
      autoplay: true,
      onLoad: () => {
        rInstance.resizeDrawingSurfaceToCanvas();
      },
    });
  } else if (riveSrc) {
    // If .hover-anim-target isn't the canvas but contains it, use the child canvas
    const canvas = el.querySelector('canvas');
    if (canvas) {
      const rInstance = new rive.Rive({
        src: riveSrc,
        canvas: canvas,
        autoplay: true,
        onLoad: () => {
          rInstance.resizeDrawingSurfaceToCanvas();
        },
      });
    }
  }
});

if (document.getElementById("bird-newsletter")) {
    const newsletter = new rive.Rive({
      src: "https://cdn.shopify.com/s/files/1/0978/8886/2545/files/newsletter_-_input_2.riv?v=1768472875",
      canvas: document.getElementById("bird-newsletter"),
      autoplay: true,
      stateMachines: "State Machine 1", // You may need to adjust the state machine name
      onLoad: () => {
        newsletter.resizeDrawingSurfaceToCanvas();
  
        let smInputs = newsletter.stateMachineInputs("State Machine 1");
        // Find the Flare number input
        const flareInput = smInputs.find(input => input.name === "Flare" && typeof input.value === "number");
        const newsletterCanvas = document.getElementById("bird-newsletter");
  
        // Helper to safely set Flare to 1 or 0
        const setFlare = (val) => {
          if (flareInput && typeof flareInput.value === "number") {
            flareInput.value = val;
          }
        };
  
        // When .save-order__email input is focused/blurred
        const emailInput = document.querySelector(".bird-flare-input");
        if (emailInput) {
          emailInput.addEventListener("focus", () => {
            setFlare(1);
          });
          emailInput.addEventListener("blur", () => {
            setFlare(0);
          });
        }
  
        // Control Flare on mouse/focus events
        if (newsletterCanvas) {
          newsletterCanvas.addEventListener("mouseenter", () => {
            setFlare(1);
          });
          newsletterCanvas.addEventListener("mouseleave", () => {
            setFlare(0);
          });
          // Accessibility: also fire on focus/blur
          newsletterCanvas.addEventListener("focus", () => {
            setFlare(1);
          });
          newsletterCanvas.addEventListener("blur", () => {
            setFlare(0);
          });
        }
      },
    });
  }




if (document.getElementById("footer-cartoon")) {
  const footerCartoon = new rive.Rive({
    src: "https://cdn.shopify.com/s/files/1/0978/8886/2545/files/footer-llama_1.riv?v=1768420490",
    canvas: document.getElementById("footer-cartoon"),
    autoplay: true,
    stateMachines: ["State Machine 1"], // You may need to adjust the state machine name
    onLoad: () => {
      footerCartoon.resizeDrawingSurfaceToCanvas();
    },
  });
}
if (document.getElementById("llama-eye-tracking")) {
  // Setup Rive llama eye tracking animation to follow the mouse across the whole screen
  const canvas = document.getElementById("llama-eye-tracking");

  const rumplelooks = new rive.Rive({
    src:
      "https://cdn.shopify.com/s/files/1/0978/8886/2545/files/llama-eye-tracking-input_1.riv?v=1768465118",
    canvas: canvas,
    autoplay: true,
    artboard: "Artboard",
    stateMachines: ["EyeTrack"],
    onLoad: () => {
      rumplelooks.resizeDrawingSurfaceToCanvas();
      const inputs = rumplelooks.stateMachineInputs("EyeTrack");
  
      const xInput = inputs.find((input) => {
        return input.name === "xAxis";
      });
  
      const yInput = inputs.find((input) => {
        return input.name === "yAxis";
      });
      const maxWidth = window.innerWidth;
      const maxHeight = window.innerHeight;
      // This assumes your blend state for x and y axis goes from 0-100
      window.addEventListener("mousemove", function (e) {
        xInput.value = (e.x / maxWidth) * 100;
        yInput.value = 100 - (e.y / maxHeight) * 100;
      });
    }
  });
}